export const ICONS: Record<string, Record<string, string>> = {
  report_type: {
    immigration_enforcement: 'group',
    checkpoint_activity: 'verified_user',
    civil_liberty_violation: 'warning',
    extremist_activity: 'warning',
    police_misconduct: 'electric_bolt',
    other_activity: 'instant_mix',
  },
  sources: {
    eyewitness_account: 'visibility',
    secondary_account: 'chat',
    news_media: 'newspaper',
    social_media: 'share',
    official_document: 'description',
  },
  location: {
    current: 'my_location',
    map: 'map',
  },
};
